module.exports = "<ul id=\"u-menu\">\n  <li *ngFor=\"let p of pageList\" style=\"margin-top: 7px;\"><a href=\"\" routerLink=\"{{p.KP_Redirect_URL}}\" routerLinkActive=\"menu-active\"><img src=\"/assets/images/icons/{{p.KP_Image_URL}}\"><span style=\"display:block;font-size:13px;\">{{p.KHB_Page}}</span></a></li>\n</ul>\n<div class=\"clearfix\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/finance/finance-menu/finance-menu.component.html
// module id = ./src/app/finance/finance-menu/finance-menu.component.html
// module chunks = main